module.exports = __webpack_public_path__ + "static/media/donut.e4d8546f.png";